//
export default [
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'código interno',
        value: 'internal_code',
        width: '15%',
    },
    {
        text: 'alias',
        value: 'alias_name',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'inventariable',
        value: 'wh_item_is_inventoriable',
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'reenvasable',
        value: 'is_repackaged',
        align: 'center',
        format: 'boolean',
    },
]
